import { Component, effect, Input, model } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { debounceTime, distinctUntilChanged, Observable, Subject, switchMap, takeUntil, tap } from 'rxjs'
import { PricingManagerClient, ProductType } from 'src/app/shared/services/ppv.api'

@Component({
   selector: 'vetcor-pricing-new-code',
   templateUrl: './vetcor-pricing-new-code.component.html',
   styleUrl: './vetcor-pricing-new-code.component.scss',
   standalone: false,
})
export class VetcorPricingNewCodeComponent {
   showDialog = model<boolean>(false)
   _showDialog = false

   @Input() practiceSKey: number = 0

   isSearching: boolean = false
   public productSearchResults: Array<any> = []
   public newProductType = model<ProductType>(undefined)
   public isPerfect: string = ''
   public whyNotPerfect: string = ''
   public hasSimilar: string = ''
   public hasFee: string = ''
   public hasQtyBreak: string = ''
   public vcProduct: any = {}
   public searchResults: Array<any> = []
   public cantFindCode: boolean = false
   public descCantFind: string = ''
   public newProductCode: string = ''
   public newProductName: string = ''
   public similarCode: string = ''
   public similarCodeDifference: string = ''
   public supplierSwitchDifference: string = ''
   public productLink: string = ''
   public productFee: number
   public qtyBreak: string = ''
   public oldCost: number
   public oldCostNA = false
   public newCost: number
   public similarProduct: any = undefined
   public searchVcProduct$ = new Subject<string>()
   public searchProduct$ = new Subject<string>()

   private cancel$ = new Subject()

   constructor(private pricingManagerClient: PricingManagerClient, private toastr: ToastrService) {
      effect(() => {
         this.reset()
         this._showDialog = this.showDialog()
         if (!this._showDialog) {
            this.cancel$.next(true), (this.searchResults = [])
         }
      })
   }

   ngOnInit(): void {
      this.searchProduct$
         .pipe(
            debounceTime(500),
            distinctUntilChanged(),
            tap((term) => {
               console.log(term)
               this.isSearching = true
            }),
            switchMap((term: string) =>
               this.pricingManagerClient.searchProduct(this.practiceSKey, term, undefined, this.newProductType()).pipe(
                  tap((data) => {
                     this.processPimsProducts(data)
                     this.isSearching = false
                  }),
                  takeUntil(this.cancel$)
               )
            )
         )
         .subscribe({
            next: (data) => {
               this.productSearchResults = this.showDialog() ? data : []
            },
         })

      this.searchVcProduct$
         .pipe(
            debounceTime(500),
            distinctUntilChanged(),
            tap((term) => {
               console.log(term)
               this.isSearching = true
            }),
            switchMap((term: string) =>
               this.pricingManagerClient.searchVCProducts(term, this.practiceSKey, undefined, this.newProductType()).pipe(
                  tap(() => {
                     this.isSearching = false
                  }),
                  takeUntil(this.cancel$)
               )
            )
         )
         .subscribe({
            next: (data) => {
               this.searchResults = this.showDialog() ? data : []
            },
         })
   }

   processPimsProducts(data: any) {
      data.forEach((product) => {
         let newName = product.productName

         if (!!product.code) newName = '(' + product.code + ') - ' + newName

         data.displayName = newName
      })
   }

   onSubmit() {
      this.pricingManagerClient
         .submitNewCodeRequest({
            cantFindDescription: this.cantFindCode ? this.descCantFind : undefined,
            newProductCode: this.newProductCode,
            newProductName: this.newProductName,
            notPerfectReason: this.isPerfect == 'yes' ? undefined : this.whyNotPerfect,
            oldCost: this.hasSimilar == 'yes' ? (this.oldCostNA ? undefined : this.oldCost) : undefined,			
			newCost: this.newCost,
            productFee: this.hasFee == 'yes' ? this.productFee : undefined,
            productLink: this.productLink,
            qtyBreak: this.hasQtyBreak == 'yes' ? this.qtyBreak : undefined,
            similarProductSKey: this.hasSimilar == 'yes' ? this.similarProduct?.productSKey : undefined,
            similarCodeDifference: this.hasSimilar == 'yes' ? this.similarCodeDifference : undefined,
            vcProductSKey: this.cantFindCode ? undefined : this.vcProduct?.vcProductSKey,
            practiceSKey: this.practiceSKey,
            id: 0,
            requestedUserId: 0,
         })
         .subscribe({
            next: () => {
               this.toastr.success('New code request submitted successfully.  The pricing team will be in contact with you shortly.')
               this.showDialog.set(false)
               this.reset()
            },
            error: () => {
               this.toastr.error('ERROR in communication with server. If the problem persists, please contact support!')
            },
         })
   }

   reset() {
      this.isPerfect = ''
      this.whyNotPerfect = ''
      this.hasSimilar = ''
      this.hasFee = ''
      this.hasQtyBreak = ''
      this.vcProduct = undefined
      this.searchResults = []
      this.cantFindCode = false
      this.descCantFind = ''
      this.newProductCode = ''
      this.newProductName = ''
      this.similarProduct = undefined
      this.similarCodeDifference = ''
      this.supplierSwitchDifference = ''
      this.productLink = ''
      this.productFee = undefined
      this.qtyBreak = undefined
      this.oldCost = undefined
      this.newCost = undefined
   }

   onProductSearch(term: string) {
      this.searchProduct$.next(term)
   }

   onVcProductSearch(term: string) {
      this.searchVcProduct$.next(term)
   }

   getProductLabel(p) {
      return `(${p.code}) - ${p.productName} `
   }
   
   onOldCostNAChecked() {
      if (this.oldCostNA) {
         this.oldCost = null
      }
   }
}
